export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  // "Aguardando atendimento" (modelo B / IA mode): conversas que a IA entregou
  // e seguem dela até um humano assumir. Aba dinâmica — só aparece com o gate ON
  // e awaiting_count > 0 (filtragem em ChatList.vue). A posição aqui dita a ordem
  // (Minhas / Aguardando atendimento / IA / Todas no modo IA).
  awaiting: {
    count: 'awaitingCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  // "Aguardando encerramento": fila irmã — conversas paradas/encerradas que a IA
  // marcou para um humano julgar o fecho. Dinâmica (gate ON + awaitingClosureCount
  // > 0, filtragem em ChatList.vue). Fica na linha 2 junto de "Aguardando atendimento".
  pending_closure: {
    count: 'awaitingClosureCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  // Order of the keys dictates the tab order (Mine / [Awaiting] / [Unassigned] / AI / All)
  ai: {
    count: 'aiCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
